"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Croupier = void 0;
const blackjack_scoring_1 = require("../blackjack-scoring");
const logic_metrics_1 = require("../logic-metrics");
const logic_types_1 = require("../logic-types");
class Croupier {
    get canDeal() {
        return blackjack_scoring_1.BlackjackScoring.canCroupierDeal(this.currentScore);
    }
    get isBust() {
        return blackjack_scoring_1.BlackjackScoring.hasBust(this.currentScore);
    }
    get currentScore() {
        const croupierCards = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        return blackjack_scoring_1.BlackjackScoring.calculateScore(croupierCards.allCards, this.logicVersion);
    }
    get displayScore() {
        return blackjack_scoring_1.BlackjackScoring.croupierDisplayScore(this.currentScore);
    }
    get displayCards() {
        return this.allFaceAndHiddenCards
            .map((card) => card.displayDescription())
            .join(", ");
    }
    get allFaceCards() {
        const croupierCards = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        return croupierCards.allCards.filter((card) => card.isFaceUp);
    }
    get allFaceAndHiddenCards() {
        const croupierCards = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        return croupierCards.allCards.filter((card) => card.isFaceUp || card.isHidden);
    }
    get allHiddenCards() {
        const croupierCards = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        return croupierCards.allCards.filter((card) => card.isHidden);
    }
    get croupierBlackjackPeekIndex() {
        const croupierCards = this.board.croupier;
        if (croupierCards.cardCount === 2) {
            const [firstCard, secondCard] = croupierCards.allCards;
            if (firstCard.cardId && secondCard) {
                const totalCards = logic_metrics_1.LogicMetrics.DeckCards * logic_metrics_1.LogicMetrics.NumberDecks;
                if (firstCard.cardId.isAce) {
                    // Check for second card 'isValuedTen'
                    return secondCard.index + totalCards + totalCards;
                }
                else if (firstCard.cardId.isValuedTen) {
                    // Check for second card 'isAce'
                    return secondCard.index + totalCards;
                }
            }
        }
        return undefined;
    }
    constructor(board, logicVersion) {
        this.board = board;
        this.logicVersion = logicVersion;
    }
    clone() {
        return new Croupier(this.board.clone(), this.logicVersion);
    }
}
exports.Croupier = Croupier;
